import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tbackground-image: linear-gradient(\n\t\t\t", " 1px,\n\t\t\ttransparent 1px\n\t\t),\n\t\tlinear-gradient(\n\t\t\t90deg,\n\t\t\t", " 1px,\n\t\t\ttransparent 1px\n\t\t);\n\tbackground-size: ", "\n\t\t", ";\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: linear-gradient(\n\t\t\t\t90deg,\n\t\t\t\t", "\n\t\t\t\t\t", ",\n\t\t\t\ttransparent 1%\n\t\t\t)\n\t\t\tcenter,\n\t\tlinear-gradient(\n\t\t\t\t", "\n\t\t\t\t\t", ",\n\t\t\t\ttransparent 1%\n\t\t\t)\n\t\t\tcenter,\n\t\t", ";\n\tbackground-size: ", "\n\t\t", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Surface = css(_templateObject(), ui.get('surfaceColor'), ui.color.text);
export var background = css(_templateObject2(), ui.get('surfaceBackgroundColor'));
export function getBorders(_ref) {
  var border = _ref.border,
      borderBottom = _ref.borderBottom,
      borderLeft = _ref.borderLeft,
      borderRight = _ref.borderRight,
      borderTop = _ref.borderTop;
  var borderStyle = "1px solid " + ui.get('surfaceBorderColor');
  return css({
    border: border && borderStyle,
    borderBottom: borderBottom && borderStyle,
    borderLeft: borderLeft && borderStyle,
    borderRight: borderRight && borderStyle,
    borderTop: borderTop && borderStyle
  });
}
export var secondary = css(_templateObject3(), ui.get('surfaceBackgroundTintColor'));
export var tertiary = css(_templateObject4(), ui.get('surfaceBackgroundTertiaryColor'));
export var dotted = css(_templateObject5(), ui.get('surfaceBackgroundColor'), ui.get('surfaceBackgroundSizeDotted'), ui.get('surfaceBackgroundColor'), ui.get('surfaceBackgroundSizeDotted'), ui.get('surfaceBorderBoldColor'), ui.get('surfaceBackgroundSize'), ui.get('surfaceBackgroundSize'));
export var grid = css(_templateObject6(), ui.get('surfaceBackgroundColor'), ui.get('surfaceBorderSubtleColor'), ui.get('surfaceBorderSubtleColor'), ui.get('surfaceBackgroundSize'), ui.get('surfaceBackgroundSize'));